import api_config_portail from '../../../api/config/_portail'
import api_clinique_portail from '../../../api/clinique/_portail'
import api_caisse_portail from '../../../api/comptabilite/_portail'

// PORT-001 : enveloppes promesse du contrôle des sorties. Les jetons courts restent dans l'appel.
export default {
    getAccesPortail() {
        return new Promise((resolve, reject) => {
            api_config_portail.getAccesPortail().then(resolve, reject)
        })
    },
    getAccesPassagePortail() {
        return new Promise((resolve, reject) => {
            api_config_portail.getAccesPassagePortail().then(resolve, reject)
        })
    },
    getPatientsLiberes(data, access_token) {
        return new Promise((resolve, reject) => {
            api_clinique_portail.getPatientsLiberes(data, access_token).then(resolve, reject)
        })
    },
    getVerdictsPaiement(data, access_token) {
        return new Promise((resolve, reject) => {
            api_caisse_portail.getVerdictsPaiement(data, access_token).then(resolve, reject)
        })
    },
    constaterSortie(data, access_token) {
        return new Promise((resolve, reject) => {
            api_clinique_portail.constaterSortie(data, access_token).then(resolve, reject)
        })
    }
}
